export const CZJS = {
    wizard: {
        selectDate:
            'Select your move in date',
        insuranceCoverage: {
            title: 'Insurance Coverage',
            pickerText: 'Maximum Replacement Value of '
        }
    },
    contact_card: {
        move_in_date:
            'Select your move in date',
    },
};
